import React from 'react';
import Lottie from "lottie-react-web";
import loadingSpinner from "~/assets/animations/spinner.json";
import loadingSpinnerWhite from "~/assets/animations/spinner_white.json";
import styled from 'styled-components';

const LoadingContainer = styled.div`
  width: 20%;
  margin: ${props => props.margin ? props.margin : '70% auto'};

  @media(min-width: 425px) {
    width: 10%;
    margin: 25% auto;
  }

  @media(min-width: 800px) {
    width: ${props => props.width ? props.width : '5%'};
    margin: ${props => props.margin ? props.margin : '10% auto'};
  }
`;

const LoadingContainerDesktop = styled.div`
  width: 15%;
  margin: ${props => props.margin ? props.margin : '70% auto'};
`

export default function Loading({ loadingColor, margin }) {
  return(
    <LoadingContainer margin={margin}>
      {
        loadingColor === 'white' ? (
          <Lottie
            options={{
              animationData: loadingSpinnerWhite
            }}
          />
        ) : (
          <Lottie
            options={{
              animationData: loadingSpinner
            }}
          />
        )
      }
    </LoadingContainer>
  );
}

export function LoadingStatus() {
  return (
    <LoadingContainer margin={'20% auto'}>
      <Lottie
          options={{
            animationData: loadingSpinner
          }}
        />
    </LoadingContainer>
  );
}

export function LoadingStatusDesktop() {
  return (
    <LoadingContainerDesktop margin={'5% auto'}>
      <Lottie
          options={{
            animationData: loadingSpinner
          }}
        />
    </LoadingContainerDesktop>
  );
}